<template>
<el-form-item
    label-width="100px"
    :class="{'required': data.isRequired,}"
    :required="data.isRequired"
    style="text-align:left">
  <span slot="label">{{data.controlName}}</span>
  <div :class="{'v-check': data.isRequired}">
    <el-input
      maxlength="500"
      show-word-limit
      v-model="data.controlValue"
      :placeholder="data.controlDefValue"
      rows="5"
      type="textarea"
    ></el-input>
  </div>
</el-form-item>
</template>

<script>
export default {
  name: 'TpTextarea',
  props: {
    data: {
      type: Object,
      required: true
    },
    model: Object
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/textarea.vue